import { cx, type LinariaClassName } from "@linaria/core"
import { styled } from "@linaria/react"


import { AgentIterationStyles } from "@/components/AgentIteration/AgentIterationStyles.ts"
import { EllipsisContainer } from "@/components/Ellipsis/Ellipsis.ts"
import { Horizontal } from "@/components/Flex.ts"
import { MarkdownWrapper } from "@/components/Markdown/MarkdownWrapper.tsx"
import { ReasoningResult_Icon } from "@/components/ReasoningStep/ReasoningResult_Icon.tsx"
import * as textStyles from "@/styles/textStyles.ts"

import type { UIToolCallObservation } from "@/lib/client/generated/TypeDefinitions.ts"

export const ReasoningResult_Message = (props: {
  content: UIToolCallObservation.Message
  inProgress: boolean,
  className?: LinariaClassName
}) => {
  const className = cx(props.inProgress ? AgentIterationStyles.secondLevelText_Loading : null, AgentIterationStyles.secondLevelText, props.className)

  return (
    <Message className={className}>
      <ReasoningResult_Icon icon={props.content.icon} />
      <EllipsisContainer>
        <MarkdownWrapper
          text={props.content.message}
          inlineOnly
          className={props.content.icon === "ERROR" ? AgentIterationStyles.secondLevelMarkdownFull : AgentIterationStyles.secondLevelMarkdown} />
      </EllipsisContainer>
    </Message>
  )
}

const Message = styled(Horizontal)`
  display: inline-flex;

  align-items: center;
  gap: 4px;

  ${textStyles.smallestFontSize};
  ${textStyles.breakWord};
`